import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import $ from "jquery";
import { fetchApi } from "../../helper/api";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { renderSensorIcon } from "../../helper/function";
import { IsAlert } from "../atoms/IsAlert";
import ListSensorTanpaIndicator from "../molecules/popup/ListSensorTanpaIndicator";
import LayoutCanvas from "./layoutCanvas";

$.Datatable = require("datatables.net");

const ContentStructureMonitor = ({ dataIpc, idBridge, role }) => {
  const [state, setState] = useState({
    activeDrags: 0,
    deltaPosition: {
      x: 0,
      y: 0,
    },
    controlledPosition: {
      x: -400,
      y: 200,
    },
    image: null,
    imagePost: null,
    changePosition: false,
    dataListSensor: null,
    listSensor: null,
    layout: null,
    noIPC: "",
    namaLayoutBaru: "",
    open: false,
    openSensor: false,
    openIPC: false,
    isIPCC: false,
  });

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getData();
      getSensor();
    }
    return () => (isMounted = false);
  }, []);

  useEffect(() => {
    // console.log("DATA IPC: ", this.props.dataIpc);
    if (dataIpc && dataIpc?.serialNumber?.split("-")[0] === "IPCC") {
      setState((current) => {
        return { ...current, isIPCC: true };
      });
    }
  }, [dataIpc]);

  const getData = async () => {
    const req = await fetchApi(
      `api/Layout/${dataIpc?.serialNumber}`,
      "GET",
      true
    );
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      setState((current) => {
        return { ...current, layout: res.data };
      });
    }
  };
  const getSensor = async () => {
    const req = await fetchApi(
      `api/Rtu/ipc/${dataIpc?.serialNumber}`,
      "GET",
      true
    );
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      setState((current) => {
        return { ...current, listSensor: res.data };
      });
    }
  };

  const getDataSensor = (sensorName) => {
    // console.log(sensorName);
    // const dataAccelerometer = dataSensor.filter((e) => e.sensor === sensorName)
    // return dataAccelerometer[0]
    setState((current) => {
      return { ...current, dataListSensor: sensorName };
    });
  };

  return (
    <div>
      <ListSensorTanpaIndicator
        data={state?.dataListSensor}
        ipc={dataIpc?.serialNumber}
      />
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="mb-0">Pemantauan Struktur</h1>
        {!state.isIPCC && (
          <div className="d-flex">
            <Link
              to={`/sensor-monitor/history-bridge/${idBridge}`}
              className="btn btn-warning mr-2 d-flex align-items-center"
              onClick={() => {
                // navigate("/sensor-monitor/history-bridge/" + this.props.idBridge)
              }}
            >
              <i className="las la-history mr-1"></i>
              Lihat History
            </Link>
            <Link
              to={`/download/${dataIpc?.serialNumber}`}
              className="btn btn-primary d-flex align-items-center"
              onClick={() => {
                // navigate("/sensor-monitor/history-bridge/" + this.props.idBridge)
              }}
            >
              <i className="las la-history mr-1"></i>
              Download
            </Link>
          </div>
        )}
      </div>
      <div className="row mt-4">
        {state.listSensor &&
          Object.entries(state.listSensor).map((e, i) => {
            return (
              <div
                className={
                  Object.entries(state.listSensor).length > 1
                    ? "col-lg-4"
                    : "col-lg"
                }
                key={i}
              >
                <span
                  onClick={() => getDataSensor(e[1])}
                  className={`shortcut position-relative cursor-pointer shortcut-hijau`}
                  data-toggle="modal"
                  data-target="#listSensor_modal"
                >
                  <div className="card z-2 bg-white p-2  rounded-banget shadow d-flex justify-content-between align-items-center flex-row">
                    <img
                      src={renderSensorIcon(e[0])}
                      alt="sensor"
                      width={40}
                      height={40}
                    />
                    <div className="d-flex align-items-center w-100 flex-row">
                      <div className="mx-2">
                        <p
                          className="mb-0"
                          style={{ fontSize: "18px", fontWeight: 600 }}
                        >
                          {e[0]}
                        </p>
                        <p className="mb-0">{e[1].length} Sensor</p>
                      </div>
                    </div>
                    <div>
                      <AvatarGroup total={e[1].length}>
                        {e[1].map((d, n) => {
                          if (n < 3) {
                            return (
                              <Avatar key={n} sx={{ backgroundColor: "#ccc" }}>
                                {d.group.charAt(0)}
                                {d.numberSensor}
                              </Avatar>
                              // <Avatar key={i} sx={{ backgroundColor: d.active ? "#5BC673" : "#d9534f" }}>{d.sensor_id}</Avatar>
                            );
                          }
                        })}
                      </AvatarGroup>
                    </div>
                  </div>
                </span>
              </div>
            );
          })}
      </div>
      <ul className="nav nav-tabs mb-3" id="pills-tab" role="tablist">
        {state.layout &&
          state.layout.map((e, i) => {
            if (i === 0) {
              return (
                <li className="nav-item" role="presentation" key={i}>
                  <button
                    className="nav-link active"
                    data-toggle="pill"
                    data-target={`#layout_${e._id}`}
                    type="button"
                    role="tab"
                    aria-selected="true"
                  >
                    {e.namaLayout}
                  </button>
                </li>
              );
            } else {
              return (
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    data-toggle="pill"
                    data-target={`#layout_${e._id}`}
                    type="button"
                    role="tab"
                    aria-selected="false"
                  >
                    {e.namaLayout}
                  </button>
                </li>
              );
            }
          })}
      </ul>
      <div className="d-flex flex-lg-row flex-column justify-content-start align-items-center  mb-3">
        <span>Keterangan warna : </span>
        <div className="d-flex align-items-center mx-lg-2">
          <div>
            <div className="legend legend-hijau"></div>
          </div>
          <span className="ml-1">Baik</span>
        </div>
        <div className="d-flex align-items-center mx-lg-2">
          <div>
            <div className="legend legend-kuning"></div>
          </div>
          <span className="ml-1">Peringatan</span>
        </div>
        <div className="d-flex align-items-center mx-lg-2">
          <div>
            <div className="legend legend-merah"></div>
          </div>
          <span className="ml-1">Berbahaya</span>
        </div>
      </div>
      <div className="tab-content" id="pills-tabContent">
        {state.layout &&
          state.layout.map((e, i) => {
            return (
              <div
                key={i}
                className={`tab-pane fade ${i === 0 && "show active"}`}
                id={`layout_${e._id}`}
                role="tabpanel"
              >
                <div className="bg-white rounded-banget shadow px-2 pb-4 pt-2">
                  <LayoutCanvas
                    id={e._id}
                    layout={e.urlImage}
                    elements={e.elements}
                    isDraggable={false}
                    callbackNewPosition={(data, id) => {}}
                  />
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

const mapState = (state) => {
  return {
    _dataProfile: state.dataProfile,
  };
};

const actionCreators = (dispatch) => {
  return {};
};
export default connect(mapState, actionCreators)(ContentStructureMonitor);
